import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/fluffy.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "fairness-img",
  width: "auto",
  height: "auto",
  src: _imports_0,
  alt: "fairness fluffy"
}, null, -1)

import events from '@gd/event-bus'
import { useI18n } from 'vue-i18n'
import { marked } from 'marked'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FairnessGuarantee',
  emits: ['close'],
  setup(__props, { emit }) {

const { t } = useI18n()


const text = computed(() => {
  return marked(t('fairness.main.text') as string)
})

const clickListener = (event: Event) => {
  const target = event?.target as HTMLLinkElement
  if (target.tagName === 'A') {
    if (target.href && /#fairplay/.test(target.href)) {
      events.$emit('helpshift-article', { name: 'fairness' })
      emit('close')
    }
  }
  event.preventDefault()
}

return (_ctx: any,_cache: any) => {
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_card = _resolveComponent("t-card")!

  return (_openBlock(), _createBlock(_component_t_card, {
    plain: "",
    class: "fairness-guarantee"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_t_text, {
        innerHTML: text.value,
        onClick: clickListener
      }, null, 8, ["innerHTML"])
    ]),
    _: 1
  }))
}
}

})